export const dimensionList = [
  {
    label: "全部",
    value: 1,
  },
  {
    label: "产品",
    value: 5,
  },
  {
    label: "地区",
    value: 2,
  },
];
